import type { ApiResponse, PaginationQuery, GenreDto, SongDto } from '@lyricshub/shared';
import { api } from './api';

export const genresService = {
  async getGenres(): Promise<ApiResponse<GenreDto[]>> {
    const response = await api.get('/genres');
    return response.data;
  },

  async getGenreBySlug(slug: string): Promise<ApiResponse<GenreDto>> {
    const response = await api.get(`/genres/${slug}`);
    return response.data;
  },

  async getGenreSongs(slug: string, params?: PaginationQuery): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get(`/genres/${slug}/songs`, { params });
    return response.data;
  },
};
